<!--  / header container \ -->
<header class="headerCntr" id="header">

    <!--  / navbar \ -->
    <nav class="navbar w-100 d-flex justify-content-between" [ngClass]="{'navbar-dash-bg': accessRoute.url === '/dashboard', 'navbar-hd-bg': checkHabitdrillUrl(),'navbar-tb-bg': isThriveBot}">
        <a (click)="navigateToDashboard()" class="cursor-pointer navbar__left">
            <!-- <img src="assets/images/logo.svg" class="logo hide-on-mobile" alt="Harappa"> -->
            <img src="https://thriversity.harappa.education/assets/images/upgradEnterpriseBnW.png" class="hide-on-desktop" alt="Harappa" width="107">
        </a>
        <div class="navbar__right" *ngIf="showHeaderDropdown && !isThriveBot">
            <div class="prog__nav" id="prog__nav" *ngIf="multipleProgramMenu">
                <div class="prog__dropdown " [ngClass]="{'multiple_program-new': checkDashboardURL()}">
                    <a class="prog__dropbtn" >
                        <ng-container *ngIf="!checkDashboardURL()">Select Program/Course</ng-container></a>
                    <div class="prog__dropdown-content">
                        <div class="prog__tabs">
                            <div class="prog__tab" *ngIf="ipjPrograms.length>0">
                                <input type="checkbox" checked id="rd1" name="rd">
                                <label class="tab-label" for="rd1">Integrated Programs/Courses</label>
                                <div class="tab-content">
                                    <div *ngFor="let program of ipjPrograms">
                                        <div class="tab-prog" (click)="loadNewIpjProgram(program)">
                                            <div class="tab-img">
                                                <img [src]="program?.logo" alt="" />
                                            </div>
                                            <div class="tab-text">
                                                {{program.title}}
                                            </div>
                                            <div *ngIf="program.isActive" class="tab-icon">
                                                <!-- <i class="fa fa-check-circle" style="color: #4cb963;"></i> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="prog__tab" *ngIf="legacyPrograms.length>0">
                                <input type="checkbox" id="rd2" name="rd">
                                <label class="tab-label" for="rd2">Old Programs/Courses</label>
                                <div class="tab-content">
                                    <div *ngFor="let legacy of legacyPrograms">
                                        <div class="tab-prog" (click)="redirectToBusiness(legacy.link)">
                                            <div class="tab-img">
                                                <img [src]="legacy?.logo" alt="" />
                                            </div>
                                            <div class="tab-text">
                                                {{legacy.title}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="javascript:void(0);" style="font-size:15px;" class="icon" onclick="myFunction()">&#9776;</a>
            </div>
        </div>
        <a *ngIf="!hidePartnerLogo" class="partner-logo"> <img *ngIf="user?.partnerInfo?.logo"
                [src]="user?.partnerInfo?.logo" alt="{{user?.organization}}"></a>
        <a onclick="closeNavMobile()" class="navbar__menu--mobile link-no-underline primary-color d-md-none"
            [ngClass]="{'hide-sidebar': hideSidebar}">
            <span class="icon-nav font-12" id="iconNavMobile"></span>
        </a>
    </nav>
    <!--  \ navbar / -->

</header>
<!--  \ header container / -->
